import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Boxes, ClipboardList, Flame, SlidersHorizontal, PackageCheck, Warehouse, Sprout, ShoppingCart, Settings2 } from "lucide-react";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/skus", label: "SKUs & Inventory", icon: Boxes, testid: "nav-skus" },
  { to: "/boms", label: "Bills of Materials", icon: ClipboardList, testid: "nav-boms" },
  { to: "/production", label: "Production Runs", icon: Flame, testid: "nav-production" },
  { to: "/orders", label: "Sales Orders", icon: ShoppingCart, testid: "nav-orders" },
  { to: "/adjustments", label: "Adjustments", icon: SlidersHorizontal, testid: "nav-adjustments" },
  { to: "/receipts", label: "Purchase Receipts", icon: PackageCheck, testid: "nav-receipts" },
  { to: "/facilities", label: "Facilities", icon: Warehouse, testid: "nav-facilities" },
  { to: "/manage", label: "Manage", icon: Settings2, testid: "nav-manage" },
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen bg-[#FAFAF8]">
      <aside className="w-64 min-h-screen bg-stone-900 text-stone-200 flex flex-col border-r border-stone-800 shrink-0 sticky top-0 h-screen">
        <div className="h-16 flex items-center gap-3 px-6 border-b border-stone-800 bg-stone-950/40 cursor-pointer" onClick={() => navigate("/")} data-testid="brand-logo">
          <div className="h-9 w-9 rounded-lg bg-amber-700/90 flex items-center justify-center shrink-0">
            <Sprout className="h-5 w-5 text-amber-50" />
          </div>
          <div className="leading-tight">
            <div className="text-sm font-bold text-white tracking-tight">Fun Guy</div>
            <div className="text-[10px] uppercase tracking-widest text-stone-500">Inventory OS</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors duration-150 ${
                  isActive
                    ? "bg-stone-800 text-white font-semibold border border-stone-700/60"
                    : "text-stone-400 hover:text-stone-100 hover:bg-stone-800/80 font-medium"
                }`
              }
            >
              <n.icon className="h-4 w-4 shrink-0" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-stone-800 text-[11px] text-stone-500">
          <div className="font-medium text-stone-400">Functional Mushroom Co.</div>
          <div>4 facilities · demo data</div>
        </div>
      </aside>
      <main className="flex-1 min-w-0">{children}</main>
    </div>
  );
}

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 leading-tight">{title}</h1>
      {subtitle && <p className="text-sm text-stone-500 mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);
